import { TemplateElement, html, defineElement, when, unsafeHTML } from '@webtides/element-js';
import style from './conversion-bar.css';
import '../../../icon/icon.js';

/**
 * @property {boolean} previewMode
 * @property {string} icon
 * @property {string} title
 * @property {string} text
 * @property {LinkProperties} link
 */
export default class ConversionBar extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            previewMode: false,
            icon: '',
            title: '',
            text: '',
            link: undefined,
        };
    }

    connected() {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.intersectionRatio === 0 && this.getBoundingClientRect()?.top <= 0) {
                    this.classList.add('is-visible');
                } else {
                    this.classList.remove('is-visible');
                }
            },
            { threshold: 0 },
        );

        observer.observe(this);
    }

    template() {
        return html`
            <div class="sticky-bar z-[1001] bg-white py-16">
                <div class="container container-lg">
                    <div class="flex gap-24 md:gap-40 items-center justify-between">
                        <div class="flex gap-24 md:gap-40 items-center">
                            ${when(
                                this.icon,
                                html`
                                    <mb-icon name="${this.icon}" class="size-24 md:size-40 hidden md:flex"></mb-icon>
                                `,
                            )}
                            ${when(
                                this.title,
                                html`<h2 class="${when(this.text, 'hidden md:block')}">${this.title}</h2>`,
                            )}
                            ${when(
                                this.text,
                                html`<div class="*:first:mt-0 *:last:mb-0">${unsafeHTML(this.text)}</div>`,
                            )}
                        </div>
                        ${when(
                            this.link?.url,
                            html`
                                <a href="${this.link?.url}" class="Button btn btn-gradient max-w-[300px] min-w-fit">
                                    ${this.link?.text}
                                    <span class="Button--gradientBackground"></span>
                                    <span class="Button--content">${this.link?.text}</span>
                                </a>
                            `,
                        )}
                    </div>
                </div>
            </div>
        `;
    }
}

defineElement('mb-conversion-bar', ConversionBar);
